"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Policies_1 = require("../../classes/Policies");
var Policy_1 = require("../../classes/Policy");
var PolicyMeta_1 = require("../../classes/PolicyMeta");
var PolicyService = /** @class */ (function () {
    function PolicyService($rootScope) {
        this.$rootScope = $rootScope;
        this.policies = new Policies_1.Policies([
            new Policy_1.Policy(0, "billing", [new PolicyMeta_1.PolicyMeta(0, 0, "gateway", "none")]),
        ]);
    }
    PolicyService.prototype.getPolicies = function () {
        return this.policies;
    };
    PolicyService.prototype.setPolicies = function (policies) {
        console.log("setting policies in policy service");
        this.policies = policies;
        this.$rootScope.$broadcast("POLICY_SERVICE_POLICY_SET");
    };
    return PolicyService;
}());
PolicyService.$inject = ["$rootScope"];
exports.default = PolicyService;
